import { GetterTree } from 'vuex'
import { RootState } from '@/store/types';
import { PushApplicationState } from './types';

export const getters: GetterTree<PushApplicationState, RootState> = {
  pushApplications: state => state.pushApplications,
  pushApplication: state => state.pushApplication,
  pushOS: state => state.pushOS,
  pushOSVersions: state => state.pushOSVersions,
  pushSDKVersions: state => state.pushSDKVersions,
  pushMappVersions: state => state.pushMappVersions,
  pushFilters: state => state.pushFilters,
}